/**
 * src/i18n/fr.identite.ts
 *
 * Sous-catalogue « identité de l'événement ».
 *
 * Clés nées de la correction des noms d'événement écrits en dur (badge
 * imprimé, scanner, émargement, plan, page de maintenance).
 *
 * Pourquoi un sous-catalogue plutôt que `fr.ts` :
 *   `fr.ts` est LE point de contact de tous les lots de travail. Au lot
 *   précédent il avait été GELÉ, et chacun avait dû SIGNALER ses clés au lieu
 *   de les écrire : 47 clés à reporter à la main après la fusion, et un lot
 *   dont les tests contredisaient son propre rapport. Cette fois chaque
 *   périmètre a son fichier, il y écrit librement, et `fr.ts` ne bouge plus.
 *
 * ⚠ Jamais de nom d'événement, de date, de lieu, ni les mots figés du
 *   vocabulaire métier : jetons {eventName}, {eventDate}, {eventPlace},
 *   {eventType*}, {lexWorkshop*}, sans quoi le garde-fou passe au rouge.
 *
 * Mikael - chef de projet - 2026-09-09
 */
export const messagesIdentiteFr: Record<string, string> = {
  // ── Textes d'ACCESSIBILITÉ (aria-label) ───────────────────────────────
  // Ces deux clés naissent de défauts que l'audit n'avait PAS listés : les
  // `aria-label` de l'en-tête global (Header.tsx) et de l'écran d'accueil
  // (SplashPage.tsx) annonçaient « TNE 2026 » en dur. Le titre VISIBLE, lui,
  // était déjà interpolé depuis le lot 3, seule la version lue à voix haute
  // restait fausse. Un utilisateur de lecteur d'écran entendait donc le nom
  // d'un autre événement sur chaque page, sans que personne ne le voie.
  // Rappel utile pour la suite : un texte d'accessibilité est du texte
  // affiché, il relève du catalogue au même titre que le reste.
  'header.brand.aria': 'Accueil : {eventName}',
  'splash.identity.aria': 'Identité visuelle {eventName}',

  // ── Titre de niveau 1 de l'écran de scan (RGAA 9.1) ───────────────────
  // L'écran n'avait aucun h1 : rien ne disait à un lecteur d'écran où l'on
  // se trouve. Libellé volontairement fonctionnel (« scan des badges ») et
  // non métier : le vocabulaire métier est configurable, donc jamais figé
  // dans une chaîne. Le nom de l'événement, lui, est fourni séparément par
  // `useEventIdentity()` dans le composant.
  'exhibitorScanner.pageTitle': 'Scan des badges',
};
